import Questions from "pages/dashboard/shared/Questions/Questions";
import React from "react";

const SchoolQuestions = () => {
  return <Questions />;
};

export default SchoolQuestions;
